import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import LinkifyText from '@medflex/components/stories/LinkifyText';
import Button from '@medflex/components/stories/Button';
import useTruncatedElement from '@medflex/hooks/useTruncatedElement';
import classNames from 'classnames';

const formatDate = date => format(date, 'DD.MM.YYYY, HH:mm');

const AbsenceView = ({ absence }) => {
  const textRef = useRef(null);
  const { t } = useTranslation('physician');
  const { isTruncated, isShowingMore, toggleIsShowingMore } = useTruncatedElement(textRef);
  const headlineCn = 'text-slate-600 text-sm';
  const textCn = classNames([{ 'line-clamp-4': !isShowingMore }, 'whitespace-pre-wrap']);

  return (
    <ul className="flex flex-col space-y-4">
      <li>
        <div className={headlineCn}>
          {t('InquiryManagementModule.Absence.item.absence_period_headline')}
        </div>
        <div>
          {t('InquiryManagementModule.Absence.item.absence_period_text', {
            start: formatDate(absence.startAt),
            end: formatDate(absence.endAt),
          })}
        </div>
      </li>
      <li>
        <div className={headlineCn}>
          {t('InquiryManagementModule.Absence.item.absence_notifications_setting_headline')}
        </div>
        <div>
          {absence.allowNotifications ? (
            t('InquiryManagementModule.Absence.form.allow_notifications.yes')
          ) : (
            <Trans
              parent="span"
              t={t}
              i18nKey="InquiryManagementModule.Absence.form.allow_notifications.no"
            >
              Do <b>not</b> allow messages/requests. Show absence notice.
            </Trans>
          )}
        </div>
      </li>
      <li>
        <div className={headlineCn}>
          {t('InquiryManagementModule.Absence.item.absence_note_headline')}
        </div>
        <div>
          <div ref={textRef} className={textCn}>
            <LinkifyText>{absence.note}</LinkifyText>
          </div>
          {isTruncated && (
            <Button kind="link" onClick={toggleIsShowingMore}>
              {isShowingMore ? t('global:read_less') : t('global:read_more')}
            </Button>
          )}
        </div>
      </li>
    </ul>
  );
};

AbsenceView.propTypes = {
  absence: PropTypes.shape({
    name: PropTypes.string.isRequired,
    startAt: PropTypes.string.isRequired,
    endAt: PropTypes.string.isRequired,
    note: PropTypes.string.isRequired,
    allowNotifications: PropTypes.bool.isRequired,
  }),
};

export default AbsenceView;
